<template>
    <div>
        <ContentHeader :disabled="false" :title="lang('singleLeftMenuText1_3',language)" :tip_text_arr="headerTipArr"/>
        <Card>
            <Spin fix v-if="pieChartLoading"></Spin>
            <p slot="title" :style="{textAlign:'left',fontSize:'18px',fontWeight:'bold'}">
                {{lang('readingBookRatioText',language)}}
            </p>
            <PieChart :pie_chart_data="pieChartData" v-if="JSON.stringify(pieChartData) !== '{}'"
                      :changeCount="pieChartChangeCount"/>
        </Card>
        <br>
        <Card>
            <Spin fix v-if="barChartLoading"></Spin>
            <p slot="title" :style="{textAlign:'left',fontSize:'18px',fontWeight:'bold'}">
                {{lang('singleChineseLevelText1',language)}}
            </p>
            <BarChart :bar_chart_data="barChartData" v-if="JSON.stringify(barChartData) !== '{}'"
                      :changeCount="barChartChangeCount"/>
        </Card>
    </div>
</template>

<script>
    var _hmt = _hmt || [];
    (function() {
        var hm = document.createElement("script");
        hm.src = "https://hm.baidu.com/hm.js?4537bce4a2128c98b476fa3bc3b18f86";
        var s = document.getElementsByTagName("script")[0];
        s.parentNode.insertBefore(hm, s);
    })();

    import {lang} from "@/utils/language.js";
    import store from '@/store/index.js';
    import config from '@/utils/config.js';
    import ContentHeader from '@/components/ContentHeader.vue';
    import {getSingleData} from '@/utils/net.js';
    import PieChart from '@/components/PieChart.vue';
    import BarChart from "@/components/BarChart.vue";

    export default {
        name: "ChineseLevel",
        store,
        components: {
            BarChart,
            ContentHeader,
            PieChart,
        },
        data() {
            return {
                headerTipArr: [],
                lang: lang,
                stateLang: '',
                pieChartLoading: false,
                barChartLoading: false,
                userId: '',
                pieChartData: {},
                barChartData: {},
                pieChartChangeCount: 0,
                barChartChangeCount: 0
            }
        },
        mounted() {
            this.loadHeaderTipArr();
            this.getPieChartData();
            this.getBarChartData();
        },
        methods: {
            loadHeaderTipArr() {
                this.headerTipArr.splice(0);
                for (var i = 1; i <= 2; i++) {
                    var item = {};
                    item.title = this.lang('singleChineseLevelTipTitle' + i, this.language);
                    item.content = this.lang('singleChineseLevelTipContent' + i, this.language);
                    if (JSON.stringify(item) !== '') {
                        this.headerTipArr.push(item);
                    }
                }
            },

            getPieChartData() {
                let that = this;
                that.pieChartLoading = true;
                getSingleData({
                    context: that,
                    url: '/open/reading/primary/person',
                    params: {
                        de: config.de
                    },
                    onCallBack: function (retMap) {
                        // 加载饼状图
                        var obj = retMap.readingClassifyingRatio;
                        var tempArr = [];
                        var legendData = []
                        for (var key in obj) {
                            legendData.push(that.lang('readingBookRatio_' + key, that.language))
                            var item = {};
                            item.name = that.lang('readingBookRatio_' + key, that.language);
                            item.value = obj[key];
                            tempArr.push(item);
                        }
                        that.pieChartData.seriesData = tempArr;
                        that.pieChartData.legendData = legendData;
                        that.pieChartChangeCount++;
                        that.pieChartLoading = false;
                    },
                    onErr(res) {
                        that.$Message.error(that.lang('systemError', that.language));
                        that.pieChartLoading = false;
                    }
                })
            },

            getBarChartData() {
                let that = this;
                that.barChartLoading = true;
                getSingleData({
                    context: that,
                    url: '/open/reading/chart/lv',
                    params: {
                        de: config.de
                    },
                    onCallBack: function (retMap) {
                        var data = retMap.data;
                        var xAxisArr = retMap.levels;
                        var seriesData = [];
                        for (let index in data) {
                            for (let key in data[index]) {
                                seriesData = data[index].data;
                            }
                        }
                        that.barChartData.yAxisFormatter =  function (value, index) {
                            return (value * 100).toFixed(0) + '%';
                        }
                        that.barChartData.tooltipFormatter = function (datas) {
                            let res = datas[0].name + '<br/>'
                            let val
                            let length = datas.length
                            let i = 0
                            for (; i < length; i++) {
                                val = (datas[i].value * 100).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
                                res += '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:' + datas[i].color + ';"></span>' + datas[i].seriesName + '：' + val + '%' + '<br/>'
                            }
                            return res
                        }
                        that.barChartData.xAxisArr = xAxisArr;
                        that.barChartData.seriesData = seriesData;
                        that.barChartChangeCount++;
                        that.barChartLoading = false;
                    },
                    onErr(res) {
                        that.$Message.error(that.lang('systemError', that.language));
                        that.barChartLoading = false;
                    }
                })
            },

        },
        computed: {
            language: function () {
                this.stateLang = store.state.lang;
                return store.state.lang;
            }
        },
        watch: {
            stateLang: function () {

            }
        },
        filters: {
            numFilter(value) {
                // 截取当前数据到小数点后两位
                let realVal = parseFloat(value).toFixed(2);
                // num.toFixed(2)获取的是字符串
                return parseFloat(realVal);
            }
        }

    }
</script>

<style scoped>

</style>